<script setup lang="ts">
import SharedBandSignupWidgetTemplate from '~/components/shared/bandSignup/widgetTemplate.vue'

import { useProvideCoreFetch } from '~/composables/useProvideCoreFetch'

import { useMiscBandSignupReferralStore } from '~/stores/miscBandSignupReferral'
import { useUserStore } from '~/stores/user'

import { getAgencyInfosFromReferralCode } from '~/helpers/band/referralApi'
import pictureBuildHelper from '~/helpers/images/picture_build'

import type { GetAgencyInfoFromReferralCodeApiReturn } from '~/helpers/band/referralApi'

definePageMeta({
  async middleware() {
    const { $pinia } = useNuxtApp()
    const { coreFetch } = useProvideCoreFetch()

    const { RESET: RESET_USER } = useUserStore($pinia)
    try {
      RESET_USER()
      try {
        await coreFetch.$post('/auth/logout/')
      } catch (_) {
        // _
      }
    } catch (err) {
      throw createError({
        statusCode: 404,
      })
    }
  },
})

const {
  params: { code },
} = useRoute()
const { coreFetch } = useProvideCoreFetch()

const { SET_CODE } = useMiscBandSignupReferralStore()

onMounted(() => {
  SET_CODE(code.toString())
})

const { data: agency } = useAsyncData(
  async () => await getAgencyInfosFromReferralCode(coreFetch, code.toString()),
  {
    default: () =>
      ({
        id: 0,
        common_name: '',
        band: {
          slug: '',
          has_profile_picture: false,
        },
      }) satisfies GetAgencyInfoFromReferralCodeApiReturn,
  },
)

const picture = computed<string>(() => {
  const {
    band: { slug, has_profile_picture },
  } = agency.value

  return pictureBuildHelper({
    kind: 'band',
    size: '200_200',
    slug: has_profile_picture ? slug : undefined,
    target: 'profile_picture',
  })
})
</script>

<template>
  <div id="ignoreFontUpscale" class="ignoreFontUpscale">
    <SharedBandSignupWidgetTemplate
      :picture="picture"
      :entity-name="agency.common_name"
      :referrer-agency-id="agency.id"
      user-kind="band"
    />
  </div>
</template>
